import { makeAutoObservable } from 'mobx';

class BenefitEnrolmentViewModel {
  selectedToKeep;
  enrolment;

  constructor(enrolment) {
    makeAutoObservable(this);

    this.enrolment = enrolment;
    this.selectedToKeep = false;
  }

  updateEndDate(endDate) {
    this.enrolment.merge({endDate});
  }

  updateReasonForUnenrolment(reasonForUnenrolment) {
    this.enrolment.merge({reasonForUnenrolment});
  }

  get id() {
    return this.enrolment.id;
  }

  get benefitClass() {
    return this.enrolment.benefitClass;
  }

  get endDate() {
    return this.enrolment.endDate;
  }

  get reasonForUnenrolment() {
    return this.enrolment.reasonForUnenrolment;
  }
}

export default BenefitEnrolmentViewModel;
